import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
interface NavbarProps {
  onNavigate: (page: 'home' | 'rental') => void;
}
export function Navbar({
  onNavigate
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Über uns',
    href: '#about'
  }, {
    name: 'Kurse',
    href: '#courses'
  }, {
    name: 'Team',
    href: '#team'
  }, {
    name: 'Preise',
    href: '#preise'
  }, {
    name: 'Personal Training',
    href: '#personal-training'
  }, {
    name: 'Events',
    href: '#events'
  }, {
    name: 'Kontakt',
    href: '#footer'
  }];
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-6'}`} data-id="element-140">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="flex justify-between items-center" data-id="element-142">
          {/* Logo */}
          <a href="#" className="flex items-center group" data-id="element-143">
            <img src="https://cdn.magicpatterns.com/uploads/uuj9K1QQaCS9sqRx6P8ACg/Pink_Neon_Illustrate.png" alt="Flex Club Stretching Studio" className="h-10 w-auto object-contain" data-id="element-144" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-145">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors duration-300 hover:text-peony-500 ${isScrolled ? 'text-gray-700' : 'text-white/90'}`} data-id="element-146">
                {link.name}
              </a>)}
            <button onClick={() => onNavigate('rental')} className={`text-sm font-medium transition-colors duration-300 hover:text-peony-500 ${isScrolled ? 'text-gray-700' : 'text-white/90'}`} data-id="element-147">
              Studio mieten
            </button>
            <a href="#courses" className={`px-6 py-2 rounded-full text-sm font-semibold transition-all duration-300 ${isScrolled ? 'bg-peony-500 text-white hover:bg-peony-600 shadow-md' : 'bg-white text-peony-600 hover:bg-peony-50'}`} data-id="element-148">
              Buchen
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-149">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 rounded-md transition-colors ${isScrolled ? 'text-dark-studio' : 'text-white'}`} aria-label="Menu" data-id="element-150">
              {isMobileMenuOpen ? <X size={24} data-id="element-151" /> : <Menu size={24} data-id="element-152" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t border-gray-100 animate-fade-in-up" data-id="element-153">
          <div className="px-4 py-6 space-y-4 flex flex-col items-center" data-id="element-154">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-gray-800 hover:text-peony-500 transition-colors" data-id="element-155">
                {link.name}
              </a>)}
            <button onClick={() => {
          setIsMobileMenuOpen(false);
          onNavigate('rental');
        }} className="text-lg font-medium text-peony-600 hover:text-peony-800 transition-colors" data-id="element-156">
              Studio mieten
            </button>
            <a href="#courses" onClick={() => setIsMobileMenuOpen(false)} className="w-full text-center px-6 py-3 bg-peony-500 text-white rounded-full font-semibold shadow-lg hover:bg-peony-600 transition-colors" data-id="element-157">
              Jetzt Buchen
            </a>
          </div>
        </div>}
    </nav>;
}